/**
 * CRM v2 — tradução dos links do comercial v1 pro motor novo (Fase E1).
 *
 * As 6 "portas" antigas (menu Mais, busca da TopBar, links de notificação
 * persistidos, fallback do sino, widget da Home e o redirect /menu) chegam
 * em `/menu/comercial?openDeal=…` / `?openCard=…`. Com a flag CRM_V2_ENABLED
 * ligada, o MenuPage redireciona pra cá.
 *
 * A migração C8 criou os cards v2 com id DETERMINÍSTICO `card-mig-<dealId>`
 * e o MESMO nº humano — então todo deep-link de deal comercial antigo tem um
 * card v2 equivalente conhecido sem consultar o servidor.
 */

/** Converte a query string do comercial v1 na rota equivalente do Funil v2. */
export function traduzirLinkComercialV1(params: URLSearchParams): string {
  const alvo = params.get('openDeal') ?? params.get('openCard');
  if (!alvo) return '/admin/comercial/funil';
  // deal antigo → card migrado (id determinístico da C8); ids do motor novo
  // (card-…) passam direto; qualquer outra coisa vai como veio (o drawer
  // trata "não encontrado" com mensagem amigável).
  const cardId = alvo.startsWith('deal-') ? `card-mig-${alvo}` : alvo;
  return `/admin/comercial/funil?abrirCard=${encodeURIComponent(cardId)}`;
}
